module.exports = __webpack_public_path__ + "static/vf_mdressshoes_core.802944b6.svg";